The identifier for the specific `CandidateProfile` associated with the application.

This can be used to retrieve structured candidate details with the `candidateProfile` query.
